import { useEffect, useState } from "react";
import { Add, Remove, Close } from "@material-ui/icons";
import "./pos.css";
import { useDispatch, useSelector } from "react-redux";
import { getProducts } from "../../redux/apiCalls";
import { userRequest } from "../../requestMethods";
import { publicRequest } from "../../requestMethods";
import styled from "styled-components";
import { addProduct, clearCart, addQuantityIcon } from "../../redux/cartRedux";
import Select from "react-select";
import createCustomerInvoice from "../../components/pdf/createCustomerInvoice";
import createDeposit from "../../components/pdf/createDeposit";

const type = [
    {
        label: "Unpaid",
        value: "pending",
    },
    {
        label: "Paid",
        value: "completed",
    },
];

const ModalContainer = styled.div`
    height: 100%;
    width: 100%;
    opacity: 0.75;
    background: black;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    position: fixed;
    z-index: 10;
`;

const OverlayContainer = styled.div`
    overflow: hidden;
`;

const Overlay = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    color: white;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    top: 0;
    background-color: rgba(white, 0.5);
    visibility: visible;
`;

const ModalDetails = styled.div`
    background-color: rgba(white, 0.5);
    color: black;
    height: 100%;
    width: 50%;
    display: flex;
    z-index: 102;
    
    @media (max-width: 768px) {
        width: 100%;
    }
`;

const EmptyModalDetails = styled.div`
    background-color: rgba(white, 0.5);
    color: black;
    height: 100%;
    width: 50%;
    display: flex;
    z-index: 102;
    
    @media (max-width: 768px) {
        display: none;
    }
`;

const ModalItemContainer = styled.div`
    background-color: white;
    color: black;
    height: 100%;
    width: 100%;
    display: grid;
`;

const ColorPickerContainer = styled.div`
    overflow-y: auto;
    overflow-x: hidden;
    height: 100vh;
    display: grid;
    grid-template-columns: auto auto;
    z-index: 101;
    background: rgb(240, 240, 255);
`;

const ColorPicker = styled.img`
    margin: 20px 10px;
    cursor: pointer;
    width: 90%;
    height: 30vh;
    object-fit: contain;
    background: white;
`;

export default function OperatingExpenses() {
    const dispatch = useDispatch();
    const products = useSelector((state) => state.product.products);
    const [colorpicker, setColorPicker] = useState(false);
    const [cashierMode, setCashierMode] = useState("sales");
    const [usersData, setUsersData] = useState([]);
    const [inputs, setInputs] = useState({
        userId: "664b2763d3e65e97f6fb8f1d",
        isProduct: true,
    });
    const [itemDetails, setItemDetails] = useState({
        name: undefined,
        price: undefined,
        type: "new",
    });

    // eslint-disable-next-line
    const [paymentType, setPaymentType] = useState([
        {
            label: "Cash",
            value: "cash",
        },
        { value: "onlineTransfer", label: "Online Transfer" },
        { value: "tng", label: "Touch N Go" },
        { value: "cheque", label: "Cheque" },
        { value: "card", label: "Debit Card" },
        { value: "creditCard", label: "Credit Card" },
        { value: "ziip6", label: "ZIIP - 6 months" },
        { value: "ziip12", label: "ZIIP - 12 months" },
        { value: "ziip18", label: "ZIIP - 18 months" },
        { value: "ziip24", label: "ZIIP - 24 months" },
        { value: "others", label: "Others" },
    ]);

    const [product, setProduct] = useState({});
    const [color, setColor] = useState({});
    const [filterList, setFilterList] = useState({
        type: "watch",
    });
    // eslint-disable-next-line
    const [productfilterCategory, setProductFilterCategory] = useState({
        status: "journal",
        category: process.env.REACT_APP_PROJECT === "KLERP" ? "666051567cc7f911f72a6804" : "666050747cc7f911f72a67d7",
        brand: process.env.REACT_APP_PROJECT === "KLERP" ? "66b4556787919f73845b0303" : "6659d2e32913c98579f297a8",
    });

    // eslint-disable-next-line
    const [quantity, setQuantity] = useState(1);

    const cart = useSelector((state) =>
        state.cart ? state.cart.products : []
    );

    const principle = useSelector((state) =>
        state.user.currentUser ? state.user.currentUser.principle : null
    );

    const currentUser = useSelector((state) => state.user.currentUser);

    const NumberFormatter = new Intl.NumberFormat("en-GB", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    const total = useSelector((state) =>
        state.cart ? (state.cart.total ? state.cart.total : 0) : 0
    );

    let deconstructedProductList = [];
    cart.forEach((product) => {
        for (let i = 0; i < product.quantity; i++) {
            deconstructedProductList.push(product);
        }
    });

    useEffect(() => {
        if (colorpicker === true) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "inherit";
        }
    }, [colorpicker]);

    useEffect(() => {
        if (usersData[0] === undefined) {
            getUsers();
        }
        dispatch(clearCart());
    }, [usersData, dispatch]);

    useEffect(() => {
        getProducts(dispatch, productfilterCategory);
    }, [dispatch, filterList, productfilterCategory]);

    const getUsers = async () => {
        const res = await publicRequest.get("/users/all", {
            params: { type: "admin" },
        });
        setUsersData(res.data);
    };

    const handleChange = (e) => {
        setInputs((prev) => {
            return { ...prev, [e.target.name]: e.target.value };
        });
    };

    const handlePaymentType = (e) => {
        setInputs((prev) => {
            return { ...prev, paymentType: e.value };
        });
    };

    const handleSetItemDetails = (e) => {
        setItemDetails((prev) => {
            return { ...prev, [e.target.name]: e.target.value };
        });
    };

    const handleBillNo = (e) => {
        setInputs((prev) => {
            return { ...prev, billno: e.target.value };
        });
    };

    const handleDate = (e) => {
        setInputs((prev) => {
            return { ...prev, date: e.target.value };
        });
    };

    const handleType = (e) => {
        setInputs((prev) => {
            return { ...prev, status: e.value };
        });
    };

    const handleQuantity = (
        product,
        quantity,
        amount,
        myAmount,
        activeColor
    ) => {
        dispatch(
            addQuantityIcon({
                ...product,
                quantity,
                amount,
                myAmount,
                activeColor,
            })
        );
    };

    const handlePosCreateOrder = async () => {
        let totalItems = 0;
        cart.forEach((item) => {
            if (item.type === "watch") {
                totalItems = totalItems + 1 * item.quantity;
            }
        });
        if (cart.length === 0) {
            alert("No product added!!");
            return;
        }

        if (total - inputs.discount < 0) {
            alert("Total cannot be a negative number");
            return;
        }

        if (inputs.userId === undefined) {
            alert("Please select a customer first");
            return;
        }

        if (currentUser) {
            try {
                const createdBy = principle ? principle : currentUser._id;

                const res = await userRequest.post("/orders/journal", {
                    userId: createdBy,
                    inputs,
                    products: cart.map((item) => ({
                        productId: item._id,
                        quantity: item.amount,
                        code:
                            item.brand === "HQ"
                                ? `${item.color.name}`
                                : `${item.brand}-${item.color.name}`,
                        img: item.img,
                        price: item.color.price,
                        amount: item.amount,
                    })),
                    credit: total,
                    address: "-",
                    paymentType: inputs.paymentType,
                    isProduct: inputs.isProduct,
                    cashier: currentUser ? currentUser._id : undefined,
                    affiliateCode: inputs.affiliateCode,
                });

                if (res.data) {
                    alert("Your order has been completed");
                    createCustomerInvoice(res.data);
                    dispatch(clearCart());
                } else {
                    alert("Server issue, please contact support");
                }
            } catch (err) {
                alert(
                    "Failed to create order. Please check if the warranty is correct and belongs to this outlet. Please contact admin if you need support."
                );
            }
        } else {
            alert("Please login before checking out");
        }
    };

    const handleClear = async () => {
        dispatch(clearCart());
    };

    const handlePosDeposit = async () => {
        let totalItems = 0;
        cart.forEach((item) => {
            if (item.type === "watch") {
                totalItems = totalItems + 1 * item.quantity;
            }
        });
        if (cart.length === 0) {
            alert("No product added!!");
            return;
        }

        if (total - inputs.discount < 0) {
            alert("Total cannot be a negative number");
            return;
        }

        if (inputs.userId === undefined) {
            alert("Please select a customer first");
            return;
        }

        if (total - inputs.deposit < 0) {
            alert("Deposit cannot be more than sales total");
            return;
        }

        if (!inputs.deposit) {
            alert(
                `Deposit cannot be less than ${
                    process.env.REACT_APP_COUNTRY === "SINGAPORE" ? "$" : "RM"
                } 0.00`
            );
            return;
        }

        if (currentUser) {
            try {
                const createdBy = principle ? principle : currentUser._id;
                const res = await userRequest.post("/orders/deposit", {
                    userId: createdBy,
                    inputs,
                    products: cart.map((item) => ({
                        productId: item._id,
                        quantity: item.quantity,
                        code: `${item.model}-${item.color.name}`,
                        img: item.color.img,
                    })),
                    amount: total,
                    address: "POS Sales",
                    isProduct: true,
                    cashier: currentUser ? currentUser._id : undefined,
                });

                if (res.data) {
                    alert("Your deposit has been completed");
                    createDeposit(res.data);
                    dispatch(clearCart());
                } else {
                    alert("Server issue, please contact support");
                }
            } catch (err) {
                alert("Failed to create deposit, please check with admin");
            }
        } else {
            alert("Please login before checking out");
        }
    };

    const handleAddProduct = (product, color) => {
        try {
            if (
                cart.find((item) => `${item.title}` === `${product.title}`) ===
                undefined
            ) {
                dispatch(
                    addProduct({
                        ...product,
                        activeColor: itemDetails,
                        quantity,
                    })
                );
            } else {
                dispatch(
                    addQuantityIcon({
                        ...product,
                        activeColor: itemDetails,
                        quantity,
                    })
                );
            }
        } catch {}
    };

    return (
        <div className="pos">
            <div className="userContainer">
                <div className="checkoutButtons">
                    <div
                        className="salesButton lightyellow"
                        onClick={() => setCashierMode("sales")}
                    >
                        Sales
                    </div>
                </div>

                <div className="possummaryContainer">
                    <div className="addProductItem fullWidth">
                        <label>Payment Type</label>
                        <Select
                            options={paymentType.map((paymentType, i) => {
                                return {
                                    label: paymentType.label,
                                    value: paymentType.value,
                                };
                            })}
                            onChange={handlePaymentType}
                        />
                    </div>

                    <div className="addProductItem fullWidth">
                                <label>Item Name</label>
                                <Select
                                    options={type.map((status, i) => {
                                        return {
                                            label: status.label,
                                            value: status.value,
                                        };
                                    })}
                                    onChange={handleType}
                                    placeholder="Paid / Unpaid"
                                />
                            </div>

                            <div className="addProductItem fullWidth">
                                <label>Bill No.</label>
                                <input
                                    type="text"
                                    onChange={handleBillNo}
                                    placeholder="Enter Bill No."
                                />
                            </div>

                            <div className="addProductItem fullWidth">
                                <label>Date</label>
                                <input
                                    type="date"
                                    onChange={handleDate}
                                    placeholder="Select a date"
                                />
                            </div>
                </div>

                <div className="calculator">
                    <div className="cartContainer">
                        <div className="cartTitle">Name</div>

                        <div className="cartTitle">Quantity</div>
                        <div className="cartTitle">Price</div>
                    </div>
                    {cart ? (
                        cart.map((product, i) => (
                            <div className="cartContainer" key={i}>
                                <div className="cartItem capitalize">
                                    {product.color.name}
                                </div>
                                <div className="quantityItem">
                                    <Add
                                        style={{ fontSize: "0.8rem" }}
                                        onClick={() =>
                                            handleQuantity(
                                                product,
                                                1,
                                                product.color.price,
                                                product.color.price,
                                                product.color
                                            )
                                        }
                                    />
                                    {product.amount}
                                    <Remove
                                        style={{ fontSize: "0.8rem" }}
                                        onClick={() =>
                                            handleQuantity(
                                                product,
                                                -1,
                                                product.color.price -
                                                    product.color.price -
                                                    product.color.price,
                                                product.color.price -
                                                    product.color.price -
                                                    product.color.price,
                                                product.color
                                            )
                                        }
                                    />
                                </div>
                                <div className="cartItem">
                                    {process.env.REACT_APP_COUNTRY ===
                                    "SINGAPORE"
                                        ? "$"
                                        : "RM"}
                                    {product.color.price}
                                </div>
                            </div>
                        ))
                    ) : (
                        <></>
                    )}
                </div>
                <div className="summary">
                    <div className="summarysubtotal">SubTotal </div>
                    <div className="summarysubtotal">
                        {process.env.REACT_APP_COUNTRY === "SINGAPORE"
                            ? "$"
                            : "RM"}
                        {total ? NumberFormatter.format(total) : "0"}
                    </div>
                </div>

                {cashierMode === "sales" && (
                    <>
                        <div className="summary totalButton">
                            <div className="summarysubtotal">Total </div>
                            <div className="summarysubtotal">
                                {process.env.REACT_APP_COUNTRY === "SINGAPORE"
                                    ? "$"
                                    : "RM"}
                                {inputs.discount
                                    ? NumberFormatter.format(
                                          total - inputs.discount
                                      )
                                    : NumberFormatter.format(total)}
                            </div>
                        </div>

                        <div className="checkoutButtons">
                            <div
                                className="salesButton sales"
                                onClick={handlePosCreateOrder}
                            >
                                Sales{" "}
                            </div>
                        </div>
                        <div className="checkoutButtons">
                            <div
                                className="salesButton cancelfilter"
                                onClick={() =>
                                    setProductFilterCategory({
                                        status: "active",
                                        model: undefined,
                                        brand: undefined,
                                    })
                                }
                            >
                                Reset Brand
                            </div>
                        </div>

                        <div className="checkoutButtons">
                            <div
                                className="salesButton reset"
                                onClick={handleClear}
                            >
                                Full Reset
                            </div>
                        </div>
                    </>
                )}

                {cashierMode === "deposit" && (
                    <>
                        <div className="summary depositPadding">
                            <div className="addDiscountItem">
                                <div className="summarysubtotal">Deposit</div>
                                <input
                                    name="deposit"
                                    type="number"
                                    onChange={handleChange}
                                    defaultValue={""}
                                />
                            </div>
                        </div>
                        <div className="summary totalButton">
                            <div className="summarysubtotal">Remaining </div>
                            <div className="summarysubtotal">
                                {process.env.REACT_APP_COUNTRY === "SINGAPORE"
                                    ? "$"
                                    : "RM"}
                                {NumberFormatter.format(
                                    inputs.discount && inputs.deposit
                                        ? total -
                                              inputs.discount -
                                              inputs.deposit
                                        : inputs.discount
                                        ? total - inputs.discount
                                        : inputs.deposit
                                        ? total - inputs.deposit
                                        : total
                                )}
                            </div>
                        </div>
                        <div className="">
                            <div
                                className="salesButton deposit"
                                onClick={handlePosDeposit}
                            >
                                Deposit{" "}
                            </div>
                        </div>
                    </>
                )}
            </div>

            {colorpicker && (
                <OverlayContainer>
                    <ModalContainer></ModalContainer>
                    <Overlay>
                        <EmptyModalDetails
                            onClick={() => setColorPicker(false)}
                        ></EmptyModalDetails>
                        <ModalDetails>
                            <ModalItemContainer>
                                <ColorPickerContainer>
                                    <div className="itemDetailsContainer">
                                        <button 
                                            className="close-menu-button"
                                            onClick={() => setColorPicker(false)}
                                            aria-label="Close menu"
                                        >
                                            <Close />
                                        </button>
                                        <div className="summary">
                                            <div className="addProductItem fullWidth">
                                                <label>Name</label>
                                                <input
                                                    name="name"
                                                    type="text"
                                                    onChange={
                                                        handleSetItemDetails
                                                    }
                                                    defaultValue={""}
                                                />
                                            </div>
                                        </div>

                                        <div className="summary">
                                            <div className="addProductItem fullWidth">
                                                <label>Price</label>
                                                <input
                                                    name="price"
                                                    type="number"
                                                    onChange={
                                                        handleSetItemDetails
                                                    }
                                                    defaultValue={""}
                                                />
                                            </div>
                                        </div>

                                        <button
                                            className="productListEdit mt-2"
                                            onClick={() => {
                                                handleAddProduct(
                                                    product,
                                                    color
                                                );
                                                setColorPicker(false);
                                                setItemDetails({
                                                    name: undefined,
                                                    price: undefined,
                                                    type: undefined,
                                                });
                                            }}
                                        >
                                            Add To Cart
                                        </button>
                                    </div>
                                    {color
                                        ? color.map((color, i) => (
                                              <div
                                                  className="flex flex-col"
                                                  key={i}
                                              >
                                                  <ColorPicker
                                                      src={color.img}
                                                      onClick={() => {
                                                          setColorPicker(false);
                                                          handleAddProduct(
                                                              product,
                                                              color
                                                          );
                                                      }}
                                                  />
                                                  <div className="flex justify-center">
                                                      {color.name}
                                                  </div>
                                                  <div className="flex justify-center">
                                                      RM{" "}
                                                      {NumberFormatter.format(
                                                          color.price
                                                      )}
                                                  </div>
                                              </div>
                                          ))
                                        : ""}
                                </ColorPickerContainer>
                            </ModalItemContainer>
                        </ModalDetails>
                    </Overlay>
                </OverlayContainer>
            )}
            <div className="posWrapper">
                <div className="checkoutButtons">
                    <div
                        className="salesButton lightred"
                        onClick={() => setFilterList({ type: "watch" })}
                    >
                        Select Products
                    </div>
                </div>
                <div className="posContainer">
                    {" "}
                    {products ? (
                        products.map((product, i) => {
                            return (
                                <div
                                    key={i}
                                    className="posItem"
                                    onClick={() => {
                                        setColor(product.color);
                                        setProduct(product);
                                        setItemDetails({
                                            name: `${product.brand.name} - ${product.title}`,
                                        });
                                        window.scrollTo(0, 0);
                                        setColorPicker(true);
                                    }}
                                >
                                    <div className="productDetails">
                                        {product.title}
                                    </div>
                                </div>
                            );
                        })
                    ) : (
                        <></>
                    )}
                </div>
            </div>
        </div>
    );
}
